<template>
  <div class="upload-file-cmp">
    <div v-for="(item, index) of fileList" :key="index" class="file-item">
      <span>{{item.url | nameFilter}}</span>
      <i class="el-icon-close cancel" @click="remove(index)" />
    </div>
    <el-upload
      class="upload-demo"
      :action="uploadUrl"
      :headers="{ Authorization }"
      :data="{ uploadType: 'PC' }"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="onSuccess">
      <el-link v-loading="loading" type="primary" icon="el-icon-plus">添加附件</el-link>
    </el-upload>
  </div>
</template>

<script>
const baseApi = process.env.VUE_APP_BASE_API
export default {
  props: {
    limit: {
      type: Number,
      default: 1
    },
    value: {
      type: [String, Array],
      default: ''
    }
  },
  filters: {
    nameFilter(val) {
      const reg = new RegExp(/\/.{32}:/)
      const str = reg.exec(val)[0]
      const vals = val.split(str)
      return vals[vals.length - 1]
    }
  },
  data() {
    return {
      uploadUrl: baseApi + 'business/commonLogin/upload',
      Authorization: sessionStorage.getItem('token'),
      loading: false,
      fileList: [],
    }
  },
  watch: {
    value() {
      this.initData()
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const { value } = this
      if (!value) {
        this.fileList = []
      } else if (typeof value === 'string') {
        this.fileList = value.split(',').map(item => ({
          status: 'success',
          url: item
        }))
      } else {
        this.fileList = value.map(item => ({
          status: 'success',
          url: item
        }))
      }
      console.log(this.fileList)
    },
    beforeUpload() {
      if (this.fileList.length >= this.limit) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件`)
        return false
      }
    },
    onSuccess(response, file, fileList) {
      console.log(response.d)
      this.fileList.push({
        status: 'success',
        url: response.d
      })
      this.submitData(this.fileList)
    },
    remove(index) {
      this.fileList.splice(index, 1)
      this.submitData(this.fileList)
    },
    submitData(fileList) {
      const urls = fileList.map((item) => {
        if (item.response) {
          return item.response.d
        } else {
          return item.url
        }
      })
      console.log(urls)
      if (typeof this.value === 'string') {
        this.$emit('input', urls.join(','))
        this.$emit('change', urls.join(','))
      } else {
        this.$emit('input', urls)
        this.$emit('change', urls)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-file-cmp{
  display: flex;
  flex-direction: column;
  .file-item{
    box-sizing: border-box;
    padding: 16px 12px;
    background: #DDE5F3;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1em;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6E6E6E;
    margin-bottom: 10px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
      word-break: break-all;
    }
    .cancel{
      cursor: pointer;
      flex-shrink: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UploadFile.vue